/**
 * Sprachvarianten gleicher Seiten (hreflang). Klein gehalten, wird auch von deutschen Seiten genutzt.
 * Seo.jsx macht daraus <link rel="alternate" hreflang="de|en|nl|x-default">.
 */
export const ALT = {
  home: () => ({ de: "/", en: "/en", nl: "/nl" }),
  products: () => ({ de: "/fotoboxen", en: "/en/photo-booths", nl: "/nl/fotoboxen" }),
  product: (slug) => ({ de: `/produkte/${slug}`, en: `/en/photo-booths/${slug}`, nl: `/nl/fotoboxen/${slug}` }),
  faq: () => ({ de: "/faq", en: "/en/faq", nl: "/nl/faq" }),
  contact: () => ({ de: "/kontakt", en: "/en/contact", nl: "/nl/contact" }),
  kreulbooth: () => ({ de: "/kreulbooth", en: "/en/kreulbooth", nl: "/nl/kreulbooth" }),
  whyUs: () => ({ de: "/ueber-uns", en: "/en/why-us", nl: "/nl/waarom-wij" }),
};

/** Gleiche Seite in einer anderen Sprache (für den Sprachumschalter); null = keine Entsprechung → Startseite. */
export function equivalentPath(pathname = "", lang = "de") {
  const p = pathname.replace(/\/+$/, "") || "/";
  const prod = p.match(/^\/(?:produkte|en\/photo-booths|nl\/fotoboxen)\/([^/]+)$/);
  if (prod) return ALT.product(prod[1])[lang];
  for (const key of ["home", "products", "faq", "contact", "kreulbooth", "whyUs"]) {
    const alt = ALT[key]();
    if (Object.values(alt).includes(p)) return alt[lang];
  }
  return null;
}

/** Sprache aus dem Pfad (für Kopf, Fuß und Leisten). */
export function langOfPath(pathname = "") {
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  if (pathname === "/nl" || pathname.startsWith("/nl/")) return "nl";
  return "de";
}
